const q = '_-9LF6'; const U = 'AzExO'; const j = 'TF-j6'; const C = 'ikxUY'; const H = 'aID0b'; const P = '-b4ZG'; const R = 'ZKIiU'; const N = 'y7-0n'; const O = 'j2HDA'; const W = '_-418T'; const I = 'G3MZQ'; const V = 'Ba0fN'; const Z = 'f8SdZ'; const n = {
  cameraModuleButton: q,
  shutterButton: U,
  submitButton: j,
  closeButton: C,
  repeatButton: H,
  cameraWrapper: P,
  video: R,
  photo: N,
  canvas: O,
  output: W,
  contentarea: I,
  loadingSpinner: V,
  spin: Z
}
function z (b, S, L) {
  let l = 0; let v = !1; let o = null; let e = null; let r = null; let u = null; let d = null; let p = null; let c = null; let h = null; let f = null; let m = !1
  function k (t) {
    const a = `
        <video class="video" autoPlay="true" playsInline="true" muted="true">Video stream steht nicht zur Verfügung.</video>
        <canvas class="canvas"> </canvas>
        <div class="output">
          <img class="photo" alt="The screen capture will appear in this box." />
        </div>
        <button class="closeButton">Schließen</button>
        <button class="repeatButton">Wiederholen</button>
        <button class="shutterButton"><div style="widtH: 100%; height: 100%; border-radius: 50%; background-color: #f4f4f4;"></div></button>
        <button class="submitButton">Senden</button>
        <div class="loadingSpinner"></div>
    `; const s = document.createElement('div')
    return s.classList.add(n.cameraWrapper), s.innerHTML = a.trim(), t.parentNode.insertBefore(s, t.nextSibling), s
  }
  function A (t) {
    const a = atob(t.split(',')[1]); const s = t.split(',')[0].split(':')[1].split(';')[0]; const i = new ArrayBuffer(a.length); const T = new Uint8Array(i)
    for (let y = 0; y < a.length; y++) { T[y] = a.charCodeAt(y) }
    return new Blob([i], { type: s })
  }
  function x () {
    const t = e.toDataURL('image/jpeg', 1); const a = A(t); const s = new FormData()
    s.append('document', a, 'image.jpg'), h.style.display = 'block', c.style.display = 'none', fetch(S, {
      method: 'POST',
      cache: 'no-cache',
      cors: 'no-cors',
      body: s
    }).then((i) => {
      if (h.style.display = 'none', c.style.display = 'block', !i.ok) { throw new Error(`HTTP error ${i.status}`) }
      return i.json()
    }).then((i) => {
      w(), L(i)
    }).catch((i) => {
      h.style.display = 'none', c.style.display = 'block', console.error(i)
    })
  }
  function M () {
    if (window.self !== window.top) {
      document.querySelector('.contentarea').remove()
      const t = document.createElement('button')
      return t.textContent = 'View live result of the example code above', document.body.append(t), t.addEventListener('click', () => window.open(location.href)), !0
    }
    return !1
  }
  function D () {
    M() || (f = k(b), o = document.querySelector('.video'), o.classList.add(n.video), e = document.querySelector('.canvas'), e.classList.add(n.canvas), r = document.querySelector('.photo'), r.classList.add(n.photo), u = document.querySelector('.closeButton'), u.classList.add(n.cameraModuleButton, n.closeButton), u.addEventListener('click', w, !1), d = document.querySelector('.repeatButton'), d.classList.add(n.cameraModuleButton, n.repeatButton), d.addEventListener('click', B, !1), p = document.querySelector('.shutterButton'), p.classList.add(n.cameraModuleButton, n.shutterButton), c = document.querySelector('.submitButton'), c.classList.add(n.cameraModuleButton, n.submitButton), c.addEventListener('click', x, !1), h = document.querySelector('.loadingSpinner'), h.classList.add(n.loadingSpinner), !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia
      ? console.error('getUserMedia is not supported on this browser or connection type. Please use an HTTPS connection.')
      : navigator.mediaDevices.getUserMedia({
        audio: !1,
        video: {
          width: { min: 1024, ideal: 1280, max: 1920 },
          height: { min: 576, ideal: 720, max: 1080 },
          facingMode: 'environment'
        }
      }).then((t) => {
        o.srcObject = t, o.play()
      }).catch((t) => {
        console.error(`An error occurred: ${t}`)
      }), o.addEventListener(
      'canplay',
      (t) => {
        v || (l = o.videoHeight / (o.videoWidth / 1280), isNaN(l) && (l = 1280 / (4 / 3)), o.setAttribute('width', 1280), o.setAttribute('height', l), e.setAttribute('width', 1280), e.setAttribute('height', l), v = !0)
      },
      !1
    ), p.addEventListener(
      'click',
      (t) => {
        E(), t.preventDefault()
      },
      !1
    ), g())
  }
  function g () {
    const t = e.getContext('2d')
    t.fillStyle = '#AAA', t.fillRect(0, 0, e.width, e.height)
    const a = e.toDataURL('image/jpg')
    r.setAttribute('src', a)
  }
  function B () {
    return m ? (m = !1, u.style.display = 'block', d.style.display = 'none', p.style.display = 'block', c.style.display = 'none', r.style.display = 'none', !0) : (m = !0, u.style.display = 'none', d.style.display = 'block', p.style.display = 'none', c.style.display = 'block', r.style.display = 'block', !1)
  }
  function w () {
    m = !1, o.srcObject?.getTracks()?.forEach(function (s) {
      s.stop()
    }), o.srcObject = null, f.parentNode.removeChild(f)
  }
  function E () {
    if (B()) { return }
    const t = e.getContext('2d')
    if (l) {
      e.width = 1280, e.height = l, t.drawImage(o, 0, 0, 1280, l)
      const a = e.toDataURL('image/png')
      r.setAttribute('src', a)
    } else { g() }
  }
  b.addEventListener('click', D, !1)
}
export {
  z as setupCamera
}
